export default __webpack_public_path__ + "static/help_02_03-b8919f9a706c701a6ac649d7c3c962b8.png";